import React from "react";
import VerificationErrorComponent from "src/components/errors/VerificationErrorComponent";

const SpoofError = () => {
  const props = {
    buttonTitle: "Contact us",
    buttonNavigateUrl: "",
    onClick: () => {
      try {
        const subject = encodeURIComponent("Support Request");
        const body = encodeURIComponent(
          `Dear Plato Support Team,\n\nI hope this message finds you well. I am reaching out regarding an issue I encountered on the verification.\n\nDetails:\n- Issue: [Please describe the issue here]\n- Date: [Specify the date of occurrence]\n- Additional Information: [Provide any additional details]\n\nBest regards,\n[Your Name]\n[Your Contact Information]`
        );
        const mailtoLink = `mailto:support@kyxplatform.ch?subject=${subject}&body=${body}`;
        window.location.href = mailtoLink;
      } catch (error) {
        alert("Unable to send the email. Please manually contact support at support@kyxplatform.ch.");
      }
    },
  };

  return <VerificationErrorComponent {...props} />;
};

export default SpoofError;